import Main from "./Main";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { BrowserRouter } from "react-router-dom";
import WithAuthentication from "Authentication/WithAuthentication.tsx";
import WithPageTitle from "utilities/withPageTitle";
import toast, { Toaster } from "react-hot-toast";
import { ScrollToTop } from "react-router-scroll-to-top";
function App() {
  return (
    <div className="App">
      <Toaster />
      <WithAuthentication>
        <BrowserRouter>
          <ScrollToTop />

          <WithPageTitle>
            <Main></Main>
          </WithPageTitle>
        </BrowserRouter>
      </WithAuthentication>
    </div>
  );
}

export default App;
